// DialogSchedule Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Grid from '../../common/grid/grid.jsx'
import ScheduleItem from '../../user/schedule_item/schedule_item.jsx'
import ScheduleDatePicker from '../../user/schedule_datepicker/schedule_datepicker.jsx'
import DateUtil from '../../../lib/dateutil.jsx'

class DialogSchedule extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      errMessage: '',
      dataDate: null
    }

    this.data = {
      bCreate: false,
      schedule: null,
      fromDate: null,
      toDate: null,
      days: [],
      previousSchedulePeriods: []
    }

    this._validateEndDate = false
    this._references = {
      refUserDatePickerFrom: React.createRef(),
      refUserDatePickerTo: React.createRef()
    }
  }

  static get propTypes () {
    return {
      defaultSchedule: PropTypes.object,
      onSubmit: PropTypes.func,
      onCreate: PropTypes.func,
      onEdit: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      defaultSchedule: null,
      onSubmit: null,
      onCreate: null,
      onEdit: null
    }
  }

  componentDidUpdate () {
    if (this._validateEndDate && this._references.refUserDatePickerTo.current) {
      this._validateEndDate = false
      this._references.refUserDatePickerTo.current.validate()
    }
  }

  show (bCreate, scheduleObj, previousSchedulePeriods) {
    this._initDataOnShow(bCreate, scheduleObj, previousSchedulePeriods)
    this.setState({ active: true })
  }

  showForEndDate (scheduleObj, previousSchedulePeriods) {
    this._validateEndDate = true
    this._initDataOnShow(false, scheduleObj, previousSchedulePeriods)
    this.setState({ active: true, errMessage: 'user.schedule.errSetEndDate' })
  }

  hide () {
    this.data.fromDate = null
    this.data.toDate = null
    this.data.days = []
    this.data.previousSchedulePeriods = []

    this.setState({
      active: false,
      errMessage: '',
      dataDate: new Date()
    })
  }

  _initDataOnShow (bCreate, scheduleObj, previousSchedulePeriods) {
    let schedule = scheduleObj
    if (bCreate) {
      schedule = this.props.defaultSchedule
    }

    this.data.bCreate = bCreate
    this.data.schedule = schedule
    this.data.fromDate =
      schedule && schedule.fromDate ? new Date(schedule.fromDate) : null
    this.data.toDate =
      schedule && schedule.toDate ? new Date(schedule.toDate) : null
    this.data.days = schedule ? schedule.schedules : []
    this.data.previousSchedulePeriods = previousSchedulePeriods || []
  }

  render () {
    const { fromDate, toDate, days, bCreate } = this.data
    const { active, errMessage } = this.state
    const classHeader = !errMessage
      ? 'dialogform-header'
      : 'dialogform-header showerr'

    return (
      <Dialog active={active} type='large'>
        {active && (
          <div className='dialog-form schedule-dialog-form'>
            <div className={classHeader}>
              {!errMessage ? (
                <div className='title'>
                  <IntlMessage
                    ident={`user.schedule.${
                      bCreate ? 'addScheduleLabel' : 'editScheduleLabel'
                    }`}
                  />
                </div>
              ) : (
                <div className='title'>
                  <IntlMessage ident={errMessage} />
                </div>
              )}
              <IconButton
                icon='wizard-close'
                className='modal wizard-close dialog-form-close'
                canHover={false}
                onClick={this._onClickClose.bind(this)}
              />
            </div>
            <div className='dialogform-content'>
              <form
                className='form'
                method='post'
                noValidate
                action='#'
                onSubmit={this._onFormSubmit.bind(this)}
              >
                <div className='scheduledate'>
                  <ScheduleDatePicker
                    label='user.schedule.userStartDate'
                    placeholder='user.schedule.noStartDatePlaceholder'
                    ref={this._references.refUserDatePickerFrom}
                    isSingleDate
                    value={fromDate ? new Date(fromDate) : null}
                    displayDate={fromDate ? new Date(fromDate) : null}
                    startDate={fromDate ? new Date(fromDate) : null}
                    endDate={toDate ? new Date(toDate) : null}
                    highlightedPeriods={this.data.previousSchedulePeriods}
                    disabledPeriods={this.data.previousSchedulePeriods}
                    onSelect={this._onSelectFromDate.bind(this)}
                    onError={this._onDateError.bind(this)}
                  />
                  <ScheduleDatePicker
                    label='user.schedule.userEndDate'
                    placeholder='user.schedule.noEndDatePlaceholder'
                    ref={this._references.refUserDatePickerTo}
                    value={toDate ? new Date(toDate) : null}
                    displayDate={toDate ? new Date(toDate) : null}
                    startDate={fromDate ? new Date(fromDate) : null}
                    endDate={toDate ? new Date(toDate) : null}
                    selectionStart={
                      fromDate ? new Date(fromDate).getTime() : null
                    }
                    selectionEnd={toDate ? new Date(toDate).getTime() : null}
                    highlightedPeriods={this.data.previousSchedulePeriods}
                    disabledPeriods={this.data.previousSchedulePeriods}
                    onSelect={this._onSelectDate.bind(this)}
                    onError={this._onDateError.bind(this)}
                  />
                </div>
                <div className='schpanel'>
                  <Grid
                    objectList={days}
                    onRenderGrid={this._onRenderGrid.bind(this)}
                  />
                </div>
              </form>
              <IconButton
                type='primary'
                size='big'
                icon='common-success-tick'
                canHover={false}
                title='expense.form.addBudgetExpense'
                onClick={this._onFormSubmit.bind(this)}
              />
            </div>
          </div>
        )}
      </Dialog>
    )
  }

  /* Event Handlers */
  _onRenderGrid (dayObj, idx) {
    const _class = `${
      dayObj.isWeekEnd ? 'schedule-item_dialog weekend' : 'schedule-item_dialog'
    }`
    return (
      <ScheduleItem
        key={idx}
        label={dayObj.title}
        availableTime={dayObj.timeAvailable}
        onSaveTime={this._onDayTimerChange.bind(this, dayObj)}
        className={_class}
      />
    )
  }

  _onDayTimerChange (dayObj, timeAvailable) {
    dayObj.timeTaken = timeAvailable
  }

  _onSelectFromDate (fromDate) {
    this.data.fromDate = fromDate ? new Date(fromDate) : null
    this.data.toDate = null

    this.setState({ errMessage: '' })
  }

  _onSelectDate (fromDate, toDate) {
    this.data.fromDate = fromDate ? new Date(fromDate) : null
    this.data.toDate = toDate ? new Date(toDate) : null

    if (this._validateDates(this.data.fromDate, this.data.toDate)) {
      if (DateUtil.isDateEqual(this.data.fromDate, this.data.toDate)) {
        this.data.toDate = null
      }

      this.setState({ errMessage: '' })
    } else {
      this.setState({ dataDate: new Date() })
    }
  }

  _validateDates (fromDate, toDate) {
    let bValid = true

    // If no from date
    if (!fromDate) {
      bValid = false
      if (this._references.refUserDatePickerFrom.current) {
        this._references.refUserDatePickerFrom.current.showError()
      }

      this.setState({ errMessage: 'user.schedule.errDateInvalid' })
    } else if (!toDate) {
      // If no end date is set
      const periods = this.data.previousSchedulePeriods
      periods.forEach((period) => {
        // If selected date is in past of previous periods
        if (
          period.from &&
          new Date(period.from).getTime() > fromDate.getTime()
        ) {
          bValid = false
          this.setState({ errMessage: 'user.schedule.errDateInvalid' })

          if (this._references.refUserDatePickerTo.current) {
            this._references.refUserDatePickerTo.current.showError()
          }
        }
      })
    } else {
      if (toDate.getTime() < fromDate.getTime()) {
        bValid = false
        this.data.fromDate = null
        this.data.toDate = null

        this.setState({ errMessage: 'user.schedule.errDateInvalid' })
      }
    }

    return bValid
  }

  _onDateError () {
    this.setState({ errMessage: 'user.schedule.errDateAlreadyExists' })
  }

  _onFormSubmit (ev) {
    ev.preventDefault()
    let noErrors = 0

    if (!this._validateDates(this.data.fromDate, this.data.toDate)) {
      noErrors++
    }

    if (noErrors === 0) {
      const updateData = {
        fromDate: this.data.fromDate,
        toDate: this.data.toDate,
        schedules: []
      }

      this.data.days.map((dayItem) => {
        updateData.schedules.push({
          dayNo: dayItem.dayNo,
          timeTaken:
            dayItem.timeTaken !== undefined
              ? dayItem.timeTaken
              : dayItem.timeAvailable
        })
      })

      if (this.data.bCreate) {
        this.props.onCreate(updateData)
      } else if (this.data.schedule.id) {
        this.props.onEdit(this.data.schedule.id, updateData)
      }
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }
}

export default DialogSchedule
